import { UserStoreAction } from '../stores/useAuthStore';
import { AxiosResponse } from 'axios';
import {
  httpService,
  embedHttpService,
  httpInviteService,
  IVerifyResponse,
  getCookie,
  setCookie,
  ENVIRONMENT,
  TApiKeys
} from 'shared';

// V3 auth
interface Tokens {
  accessToken: string;
  accessTokenExpiresOn: string;
  refreshToken: string;
  refreshTokenExpiresOn: string;
}

export const authService = {
  refreshToken: async () => {
    const oldRefreshToken = getCookie(`${ENVIRONMENT}2_yepic_refresh_token`);
    if (!oldRefreshToken) return null;
    const {
      data: { accessToken, accessTokenExpiresOn }
    } = await httpService.post<Tokens>(
      '/users/token/refresh',
      {
        refreshToken: oldRefreshToken
      },
      {
        _retry: true
      } as object
    );

    setCookie(
      `${ENVIRONMENT}_yepic_access_token`,
      accessToken,
      accessTokenExpiresOn
    );
  },
  getLivekitToken: async (
    data: {
      personaId: string;
    },
    keys?: TApiKeys
  ): Promise<{
    avatarId: string;
    voiceId: string;
    liveKitSeverUrl: string;
    liveKitUserToken: string;
    liveKitChatBotIdentity: string;
    liveKitUserIdentity: string;
  }> => {
    const headers = keys
      ? {
          'x-api-key': keys.apiKey,
          'x-agent-key': keys.agentKey
        }
      : {};

    const res = await httpService.post('chatstreams', data, { headers });
    return res.data;
  }
};
